import { ReactSVG } from 'react-svg';

import logo from '../../images/logos/af-logo.svg';
import question from '../../images/icons/home/question.svg';
import uptime from '../../images/icons/home/uptime.svg';
import productSuite from '../../images/product_suite.png';

const HomeLanding = ({
	userData,
	customer,
	locations,
	allPermissions
}) => {

	let features = [];
	locations.forEach((location) => {
		for (const [product, purchased] of Object.entries(location.purchasedProducts)) {
			if (purchased) {
				features.push(product);
			}
		}
	});

	return (
		<div className="HomeLanding">
			<iframe src="https://transitscreen.notion.site/ebd//28618116f96380ddad3ee4dfdd0ae81f" width="100%" height="600" frameBorder="0" allowFullScreen style={{overflow: "scroll"}}/>
        </div>
	)
}

export default HomeLanding
